export const AuthModalHeaders = ({ icon, title, subtitle }) => {
  return (
    <div className="auth-modal-headers">
      {icon && <div className="auth-modal-icon">{icon}</div>}
      {title && <p className="auth-modal-header-title">{title}</p>}
      {subtitle && <p className="auth-modal-header-subtitle">{subtitle}</p>}
    </div>
  );
};
